/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Oauth_ApproveInputs */



/**
* | output |
* | --- |
* | "Approve" |
*
* @param {Oauth_ApproveInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const oauth_approve = /** @type {((inputs?: Oauth_ApproveInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Oauth_ApproveInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Approuver")
	if (locale === "es") return /** @type {LocalizedString} */ ("Aprobar")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Aprovar")
	if (locale === "it") return /** @type {LocalizedString} */ ("Approva")
	return /** @type {LocalizedString} */ ("Approve")
});